<template>
  <div>
    <!--彈出視窗-->
    <v-dialog v-model="visible" persistent :max-width="width">
      <v-card>
        <v-card-title class="headline">
          {{ title }}
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text v-if="editedItem">
          <v-layout row wrap>
            <v-flex xs6 px-2>
              <v-text-field
                v-model="editedItem.displayId"
                :label="`出貨單號`"
              ></v-text-field>
            </v-flex>
            <v-flex xs6 px-2> </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs6 px-2>
              <v-select
                v-model="editedItem.storeId"
                :items="storeItemList"
                item-text="name"
                item-value="storeId"
                label="店家名稱"
              ></v-select>
            </v-flex>
            <v-flex xs6 px-2>
              <v-text-field v-model="editedItem.storePhone" :label="`*市話/手機`" disabled=""></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs6 px-2>
              <v-select
                :items="getAgentList"
                item-text="displayName"
                item-value="agentId"
                v-model="editedItem.agentId"
                label="業務名稱"
              ></v-select>
            </v-flex>
            <v-flex xs6 px-2>
              <v-select
                :items="getAgentList"
                item-text="displayName"
                item-value="agentId"
                v-model="editedItem.introducerId"
                label="介紹人"
              ></v-select>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs6 px-2>
              <v-text-field
                v-model="editedItem.introducerBonus"
                :label="`介紹人佣金`"
                type="number"
              ></v-text-field>
            </v-flex>
            <v-flex xs6 px-2>
              <v-text-field
                v-model="editedItem.deliveryStaff"
                :label="`*送貨人員`"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs6 px-2>
              <v-layout row wrap>
                <v-flex xs6 px-2>
                  <v-autocomplete
                    :items="cityList"
                    placeholder="縣市"
                    v-model="editedItem.city"
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs6 px-2>
                  <v-autocomplete
                    v-model="editedItem.street"
                    :items="
                      streetList[editedItem.city]
                        ? streetList[editedItem.city]
                        : []"
                    :disabled="!editedItem.city || editedItem.city === ''"
                    placeholder="鄉鎮區"
                  ></v-autocomplete>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs6 px-2>
              <v-text-field
                v-model="editedItem.address"
                :label="`*地址`"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs6 px-2>
              <v-text-field v-model="editedItem.transportPrice" :label="`*運費`" type="number"></v-text-field>
            </v-flex>
            <v-flex xs6 px-2>
              <v-select
                v-model="editedItem.discount"
                :items="discountList"
                item-text="text"
                item-value="key"
              ></v-select>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs6 px-2>
              <v-text-field
                v-model="editedItem.agentBonus"
                :label="`業務佣金`"
                type="number"
              ></v-text-field>
            </v-flex>
            <v-flex xs6 px-2>
              <v-select
                :items="paymentList"
                item-text="text"
                item-value="key"
                v-model="editedItem.paymentType"
                label="選擇付款方式"
              ></v-select>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs6 px-2>
              <v-select
                :items="paymentStatusList"
                item-text="text"
                item-value="key"
                v-model="editedItem.paymentStatus"
                label="付款狀態"
              ></v-select>
            </v-flex>
            <v-flex xs6 px-2>
              <v-text-field
                v-model="editedItem.paymentDate"
                :label="`付款日`"
              ></v-text-field>
              <!-- <date-picker :dateString="`付款日`" :date.sync="editedItem.paymentDate"/> -->
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs6 px-2>
              <v-text-field
                v-model="editedItem.comment"
                :label="`備註`"
              ></v-text-field>
            </v-flex>
            <v-flex xs6 px-2>

            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs6 px-2>
              <v-select
                :items="deliveryStatusList"
                item-text="text"
                item-value="key"
                v-model="editedItem.deliveryStatus"
                label="出貨狀態"
              ></v-select>
            </v-flex>
            <v-flex xs6 px-2>
              <v-text-field
                v-model="editedItem.deliveryDate"
                :label="`出貨日`"
              ></v-text-field>
              <!-- <date-picker :dateString="`出貨日`" :date.sync="editedItem.deliveryDate"/> -->
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs6 px-2>
              <v-text-field v-model="editedItem.price" :label="`總金額`" readonly></v-text-field>
            </v-flex>
            <v-flex xs6 px-2>
              <v-text-field v-model="editedItem.realPrice" :label="`*實際售價`"></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs6 px-2>
              <v-layout row wrap>
                <v-flex xs8>
                  <v-select
                    v-model="stockId"
                    :items="products"
                    item-text="id"
                    item-value="stockId"
                    label="商品"
                  ></v-select>
                </v-flex>
                <v-flex xs4 >
                  <v-btn color="primary" @click="createProduct">新增商品</v-btn>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs6 px-2> </v-flex>
          </v-layout>
          <v-layout row wrap>
            <table-view
              :columnKeys="columnKeys"
              :items="items"
              :total-items="totalItems"
              @cellEvent="cellEvent"
            >
            </table-view>
          </v-layout>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" dark text @click="cancelEvent">取消</v-btn>
          <v-btn color="primary" dark text @click="confirmEvent">確定</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import MobileDetect from "mobile-detect";
import { mapGetters, mapActions } from "vuex";
import DeliveryOrderModel from "../models/DeliveryOrderModel";
import TableView from "./TableView";
import DatePicker from "./DatePicker"
import common from '../mixins/common';

const md = new MobileDetect(window.navigator.userAgent);

export default {
  name: "DeliveryDialog",
  props: {
    visible: Boolean,
    title: String,
    item: Object,
    isNew: Boolean,
  },
  components: {
    TableView,
    DatePicker
  },
  mixins:[common],
  data() {
    return {
      width: md.phone() ? "80%" : "50%",
      cityData: require("../assets/taiwan_city"),
      cityList: [],
      streetList: {},
      salesList: [],
      products: [],
      storeItemList: [],
      items: [],
      totalItems: 0,
      stockId: "",
      editedItem: null,
    };
  },
  computed: {
    ...mapGetters(["getUserInfo", "getAgentList",'getStoreList']),
    discountList() {
      return [
        { key: 1, text: "店家優惠條款" },
        { key: 0.95, text: "95折" },
        { key: 0.9, text: "9折" },
        { key: 0.85, text: "85折" },
        { key: 0.8, text: "8折" },
        { key: 0.75, text: "75折" },
        { key: 0.7, text: "7折" },
        { key: 0.65, text: "65折" },
        { key: 0.6, text: "6折" },
        { key: 0.55, text: "55折" },
        { key: 0.5, text: "5折" },
      ];
    },
    columnKeys() {
      const list = [
        { value: "id", text: "編號", sortable: true, required: false },
        {
          value: "productNumber",
          text: "商品編號",
          sortable: true,
          required: false,
        },
        {
          value: "productCategory",
          text: "類型",
          sortable: true,
          required: false,
          options: this.categoryList,
          isSelect: true,
        },
        {
          value: "delete",
          text: "刪除",
          sortable: false,
          required: false,
          color: "red",
          isEvent: true,
        },
      ];
      return list;
    },
    categoryList() {
      return [
        { key: 0, text: "整新品" },
        { key: 1, text: "維修交換品" },
        { key: 2, text: "維修品" },
        { key: 3, text: "故障品" },
      ];
    },
  },
  watch: {
    visible(value){
      console.log(`visible == ${value}`);
      if (value === true){
        let copyItem = !this.item ? new DeliveryOrderModel() : JSON.parse(JSON.stringify(this.item))
        if(!copyItem.agentId) {
          copyItem.agentId = this.getUserInfo.agentId;
        }
        this.editedItem = copyItem;
        this.loadData();
      }
    },
    'editedItem.productList'(list){
      if(list.length > 0 && this.items.length === 0) {
        list.forEach((info) => {
          const itemInfo = this.productItem(info.stockId)
          this.sortItems(itemInfo)
        });
      }
    },
    'editedItem.storeId'(value){
      const find = this.storeItemList.find(s=>s.storeId === value);
      console.log(`store ${JSON.stringify(find)}`);
      if (find){
        this.editedItem.storePhone = find.phone;
      }
    }
  },
  created() {

  },
  methods: {
    ...mapActions([
      "orderCreate",
      "orderUpdate",
      "storeList",
      "fetchAgentList",
      "stockList",
      'fetchStoreList'
    ]),
    loadData(){
      this.fetchAgentList().then((res) => {});
      this.fetchStoreList().then((res) => {
        const find = this.getStoreList.find(s=>s.storeId === this.editedItem.storeId);
        if (find){
          this.editedItem.storePhone = find.phone;
        }
      });
      this.loadProductList();
      this.loadStoreList();
      this.cityData.taiwan.forEach((city) => {
        this.cityList.push(city.city);
        this.streetList[city.city] = city.area;
      });
    },
    createProduct() {
      const itemInfo = this.productItem(this.stockId)
      if (itemInfo) {
        const dataInfo = {
          stockId: itemInfo.stockId,
          productNumber: itemInfo.productNumber
        }
        this.editedItem.productList.push(dataInfo);
        this.sortItems(itemInfo)
      }
    },
    sortItems(itemInfo) {
      if (itemInfo) {
        this.items.push(itemInfo);
      }
      this.totalItems = this.items.length;
      this.priceTotal()
    },
    priceTotal() {
      this.editedItem.price = 0
      this.items.forEach(info => {
        this.editedItem.price += info.price
      })
    },
    productItem(id) {
      const itemArray = this.products.filter(
        (i) => i.stockId === id
      );
      return itemArray.length > 0 ? itemArray[0] : null
    },
    async confirmEvent() {
      if(this.isNew) {
        const results = await this.orderCreate(this.editedItem)
      } else {
        const results = await this.orderUpdate(this.editedItem)
      }
      this.$emit("confirmEvent");
    },
    cancelEvent() {
      this.$emit("cancelEvent");
    },
    async loadProductList() {
      const data = {
        startDate: `2020-01-01 00:00:00`,
        endDate: `2100-01-01 23:59:59`,
        pageIndex: 1,
        limit: 100000,
        searchQuery: [],
      };
      const results = await this.stockList(data);
      this.products = results.data.data.list;
    },
    async loadStoreList() {
      let result = await this.storeList();
      this.storeItemList = result.data.data;
    },
    cellEvent(props) {
      if (props.key === "delete") {
        this.deleteEvent(props.item);
      }
    },
    deleteEvent(item) {
      this.editedItem.productList.forEach((info, index) => {
        if (info.stockId === item.stockId) {
          this.editedItem.productList.splice(index, 1);
        }
      });
      this.items.forEach((info, index) => {
        if (info.stockId === item.stockId) {
          this.items.splice(index, 1);
        }
      });
      this.priceTotal()
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/DeliveryDialog.vue